import React, { useMemo } from "react";
import Link from "next/link";
import Image from "next/image";
import { useRouter } from "next/router";
import { observer } from "mobx-react-lite";
import store from "store";
import { Hooks } from "@xt/xtbase";
const { useIntl, FormattedMessage } = Hooks;
import stylesLess from "./index.module.less";
import axios from "utils/axios";
import sessionStorage from "utils/sessionStorage";
import { regexp, doRsaEncrypt } from "utils/method";
import { post_loginByFaBeforeCheck, post_passwdPublicKey } from "api/uaapi/uaa";
import { post_msgDoSendCode } from "api/uaapi/user";
import { put_faVerifyCode } from "api/uaapi/account";

import AntdModalAlert from "components/Antd/Modal/Alert";
import ButtonBig from "components/Antd/Button/big";
import Passcode from "components/App/Passcode";
import FormItem from "components/App/FormItem";
import FormItemInput from "components/App/FormItem/Input";
import FormItemPassword from "components/App/FormItem/Password";
import Geetest from "components/Geetest";
import passcode from "components/App/Passcode";
import { message } from "antd";

export default observer(
  React.forwardRef(function Mode1({ fa, errMsg, disabled, codeType = "USER_2001", onSubmit, update_btn_disabled }, ref) {
    const intl = useIntl();
    const router = useRouter();
    const { isDark } = store.app;

    // const validateItem = ["email", "mobile", "google"];
    const validateItem = {
      EMAIL: "email",
      MOBILE: "mobile",
      GA: "google"
    };
    // const { email = "", mobile = "", countryCode, faCheckId } = fa;
    const email = useMemo(() => {
      const doc = fa.items.find((obj) => obj.type === "EMAIL");
      return doc ? doc.receiveAddr : "";
    }, [fa]);
    const mobile = useMemo(() => {
      const doc = fa.items.find((obj) => obj.type === "MOBILE");
      return doc ? doc.receiveAddr : "";
    }, [fa]);
    const faItems = fa.items.sort((a, b) => b.priority - a.priority);
    const [state_type, setState_type] = React.useState(validateItem[faItems[0].type]); //0邮箱 1手机 2ga

    const [state_code, setState_code] = React.useState("");
    const [state_errMsg, setState_errMsg] = React.useState("");
    React.useEffect(() => {
      setState_code("");
      setState_errMsg("");
    }, [state_type]);
    React.useEffect(() => {
      setState_errMsg("");
      const isTwo = faItems && faItems.length > 1;
      if (state_code.length >= 6) {
        // if (isTwo) {
        //   update_btn_disabled(false);
        // } else {
        handleSubmit();
        // }
      } else {
        if (isTwo) {
          update_btn_disabled(true);
        } else {
        }
      }
    }, [state_code]);
    React.useEffect(() => {
      setState_errMsg(errMsg || "");
    }, [errMsg]);

    const [state_paste, setState_paste] = React.useState(false);
    React.useEffect(() => {
      if (navigator.clipboard) setState_paste(true);
    }, []);
    const handlePaste = async () => {
      const text = await navigator.clipboard.readText();
      const val = text.slice(0, 6);
      if (/^[0-9]+$/.test(val)) {
        setState_code(val);
        passcodeRef.current.focus();
      }
    };

    const [state_email_loading, setState_email_loading] = React.useState(false);
    const [state_email_hasSend, setState_email_hasSend] = React.useState(false);
    const [state_email_more, setState_email_more] = React.useState(0);
    const [state_second_email, setState_second_email] = React.useState(0);
    React.useEffect(() => {
      let timeoutFun;
      if (state_second_email) {
        timeoutFun = setTimeout(() => {
          setState_second_email(state_second_email - 1);
        }, 1000);
      }

      return () => clearTimeout(timeoutFun);
    }, [state_second_email]);
    const handleSendCodeEmail = () => {
      try {
        sensors.track("GetCode", {
          service_type: codeType == 102 ? "忘记密码" : "登录"
        });
      } catch (error) {}

      geetestRef.current.verify();
    };
    const handleNoReceiveCode = () => {
      AntdModalAlert({
        isDark: isDark,
        title: intl.formatMessage({ id: "register.noReceiveCodeTipTitle" }),
        content: (
          <div>
            <div style={{ marginBottom: 16 }}>{intl.formatMessage({ id: "register.noReceiveCodeTipDesc" })}</div>
            <div style={{ marginBottom: 16 }}>{intl.formatMessage({ id: "register.noReceiveCodeTipStep1" })}</div>
            <div style={{ marginBottom: 16 }}>{intl.formatMessage({ id: "register.noReceiveCodeTipStep2" }, { 0: email })}</div>
            <div>{intl.formatMessage({ id: "register.noReceiveCodeTipStep3" })}</div>
          </div>
        )
      });
    };
    const handleEmailSendCode = (puzzleValidateString) => {
      setState_email_loading(true);

      put_faVerifyCode({
        params: {
          faId: fa.faId,
          FaValidTypeDict: "EMAIL",
          msgChannelDict: "EMAIL"
        },
        errorPop: true
      })
        .then(() => {
          setState_second_email(60);
          setState_email_more(state_email_more + 1);
          setState_email_hasSend(true);
          message.success(intl.formatMessage({ id: "login.emailCodeSend" }));
        })
        .finally(() => {
          setState_email_loading(false);
        });

      /*
    const send = {
      codeType,
      // receiveAddress: email,
      // puzzleValidateString,
      faCheckId,
      msgType: 2,
      regChannel: "xt",
    };

    post_msgDoSendCode({
      params: {
        codeType,
      },
      data: send,
      errorPop: true,
      // successPop: true,
    })
      .then(() => {
        setState_second_email(60);
        setState_email_more(state_email_more + 1);
        setState_email_hasSend(true);
        message.success(intl.formatMessage({ id: "login.emailCodeSend" }));
      })
      .finally(() => {
        setState_email_loading(false);
      });
     */
    };

    const [state_mobile_loading, setState_mobile_loading] = React.useState(false);
    const [state_mobile_hasSend, setState_mobile_hasSend] = React.useState(false);
    const [state_second_mobile, setState_second_mobile] = React.useState(0);
    React.useEffect(() => {
      let timeoutFun;
      if (state_second_mobile) {
        timeoutFun = setTimeout(() => {
          setState_second_mobile(state_second_mobile - 1);
        }, 1000);
      }

      return () => clearTimeout(timeoutFun);
    }, [state_second_mobile]);
    const handleSendCodeMobile = () => {
      try {
        sensors.track("GetCode", {
          service_type: codeType == 102 ? "忘记密码" : "登录"
        });
      } catch (error) {}

      setState_msgType(0);
      geetestRef.current.verify();
    };
    const handleMobileSendCode = (puzzleValidateString) => {
      setState_mobile_loading(true);
      put_faVerifyCode({
        params: {
          faId: fa.faId,
          FaValidTypeDict: "MOBILE",
          msgChannelDict: "SMS" // 语音验证码已注释，固定为短信
        },
        errorPop: true
      })
        .then(() => {
          setState_second_mobile(60);
          setState_mobile_hasSend(true);
          let id = "login.smsCodeSend";
          // 语音验证码已注释 if (state_msgType) { id = "login.voiceCodeSend"; }
          message.success(intl.formatMessage({ id }));
        })
        .finally(() => {
          setState_mobile_loading(false);
        });

      /*
    const send = {
      codeType,
      countryCode,
      msgType: state_msgType,
      // receiveAddress: mobile,
      // puzzleValidateString,
      faCheckId,
      regChannel: "xt",
    };

    post_msgDoSendCode({
      params: {
        codeType,
      },
      data: send,
      errorPop: true,
      // successPop: true,
    })
      .then(() => {
        setState_second_mobile(60);
        setState_mobile_hasSend(true);
        let id = "login.smsCodeSend";
        if (state_msgType) {
          id = "login.voiceCodeSend";
        }
        message.success(intl.formatMessage({ id }));
      })
      .finally(() => {
        setState_mobile_loading(false);
      });
     */
    };
    const [state_msgType, setState_msgType] = React.useState(0); // 仅保留兼容，语音验证码已注释
    // const handleSendVoiceCode = () => { ... };

    const geetestRef = React.useRef();
    const handleGeetestSuccess = (puzzleValidateString) => {
      if (state_type === "email") return handleEmailSendCode(puzzleValidateString);
      if (state_type === "mobile") return handleMobileSendCode(puzzleValidateString);
    };
    React.useEffect(() => {
      if (faItems.length === 1 && /^(email|mobile)$/.test(state_type)) {
        if (state_type === "email") {
          handleSendCodeEmail();
        } else {
          handleSendCodeMobile();
        }
      }
    }, []);

    const verify = () => {
      if (!state_code || state_code.length < 6) {
        const obj = {
          mobile: "app.plsEnterRightMobileCode",
          email: "app.plsEnterRightEmailCode",
          google: "app.plsEnterRightGoogleCode"
        };
        setState_errMsg(intl.formatMessage({ id: obj[state_type] }));
        return;
      }

      handleSubmit();
    };
    const passcodeRef = React.useRef();
    const handleSubmit = () => {
      passcodeRef.current.blur();
      const send = {};
      const covertObj = {
        email: "emailCode",
        mobile: "mobileCode",
        google: "googleCode"
      };
      // send[state_type + "Code"] = state_code;
      send[covertObj[state_type]] = state_code;
      onSubmit && onSubmit(send);
    };
    React.useImperativeHandle(ref, () => ({ verify }));

    return (
      <div className={`${stylesLess.main} ${isDark ? "dark" : "light"}`}>
        <div className="iNav">
          {faItems.map((item, index) => {
            const type = validateItem[item.type];
            return (
              <button
                key={type}
                className={`btntxt loginBtn ${isDark ? "dark" : "light"} ${state_type === type ? "atv" : ""}`}
                disabled={disabled}
                onClick={() => setState_type(type)}
              >
                <FormattedMessage id={`login.${type}Code`} />
              </button>
            );
          })}
        </div>

        <div className={"iPasscodeTip"}>
          <Geetest ref={geetestRef} onSuccess={handleGeetestSuccess} />
          {state_type === "email" && <FormattedMessage id="login.emailCodeTip" values={{ 0: email.replace(/(\w{2}).*(\w{1})@(.*)/, "$1***@$3") }} />}
          {state_type === "mobile" && (
            <FormattedMessage
              id="login.mobileCodeTip"
              values={{
                0: mobile.length > 7 ? mobile.replace(/(\d{3})\d*(\d{4})/, "$1***$2") : mobile.replace(/(\d{2})\d*(\d{2})/, "$1***$2")
              }}
            />
          )}
          {state_type === "google" && <FormattedMessage id="login.googleCodeTip" />}
        </div>

        <Passcode autoFocus={true} ref={passcodeRef} disabled={disabled} errMsg={state_errMsg} value={state_code} onInput={setState_code} />

        {state_type === "email" && (
          <>
            <div className={"iResend"}>
              <button className={"btntxt"} disabled={!!state_second_email || state_email_loading} onClick={handleSendCodeEmail}>
                <FormattedMessage id={state_second_email || state_email_hasSend ? "register.resend" : "app.sendCode"} />
              </button>
              {!!state_second_email && <span>{state_second_email}s</span>}
            </div>
            {state_email_more > 1 && (
              <div className={"iResend"}>
                <button className={"btntxt"} onClick={handleNoReceiveCode}>
                  <FormattedMessage id="register.noReceiveCode" />
                </button>
              </div>
            )}
          </>
        )}
        {state_type === "mobile" && (
          <>
            <div className={"iResend"}>
              <button className={"btntxt"} disabled={!!state_second_mobile || state_mobile_loading} onClick={handleSendCodeMobile}>
                <FormattedMessage id={state_second_mobile || state_mobile_hasSend ? "register.resend" : "app.sendCode"} />
              </button>
              {!!state_second_mobile && <span>{state_second_mobile}s</span>}
            </div>
            {/* 语音验证码功能已注释 */}
            {/* <div className={"iResend"}>
              <button className={"btntxt"} onClick={handleSendVoiceCode}>
                <FormattedMessage id="login.voiceCode" />
              </button>
            </div> */}
          </>
        )}
        {state_type === "google" && state_paste && (
          <>
            <div className={"iResend"}>
              <button className={"btntxt"} onClick={handlePaste}>
                <FormattedMessage id="app.copy" />
              </button>
            </div>
          </>
        )}

      </div>
    );
  })
);
